import { type ReactElement } from 'react'
import { FormBlocker, IconEmojiColorPicker } from '@components'
import { useTranslation } from '@front/model'
import { Stack, TextInput, Textarea, Input } from '@mantine/core'
import { type UseFormReturnType } from '@mantine/form'
import { type UnsavedExternalLink } from '@terros/common'
import { LinksScopeSelect } from './LinksScopeSelect'

export type WithExternalLinkForm<T extends UnsavedExternalLink = UnsavedExternalLink> = {
  form: UseFormReturnType<T>
}

export const ExternalLinkForm = ({ form }: WithExternalLinkForm): ReactElement => {
  const { t } = useTranslation()
  const { getInputProps, values, setFieldValue } = form

  return (
    <Stack gap='lg'>
      <FormBlocker form={form} />
      <TextInput label={t('URL')} placeholder={t('Enter the link URL')} {...getInputProps('url')} />

      <TextInput label={t('Title')} placeholder={t('Enter a descriptive title')} {...getInputProps('label')} />

      <Textarea
        label={t('Description')}
        placeholder={t('description or notes')}
        rows={2}
        {...getInputProps('description')}
      />

      <Input.Wrapper label={t('Scope')}>
        <LinksScopeSelect
          value={values.scopeId}
          onChange={(scopeId) => setFieldValue('scopeId', scopeId)}
          error={getInputProps('scopeId').error}
        />
      </Input.Wrapper>

      <Input.Wrapper label={t('Appearance')}>
        <IconEmojiColorPicker
          icon={values.icon}
          onIconChange={(icon: string) => setFieldValue('icon', icon)}
          color={values.color}
          onColorChange={(color: string) => setFieldValue('color', color)}
          disableCompanyLogo
        />
      </Input.Wrapper>
    </Stack>
  )
}
